import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Button, Card, CardBody, CardHeader, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { LineChart, XAxis, YAxis, CartesianGrid, Line, Tooltip } from "recharts";
import ApiService from "../../services/apiService";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { format } from "date-fns";
import DateTimePicker from 'react-datepicker'
import LeftIcon from "../svg/LeftButton";
import RightIcon from "../svg/RightIcon";

type chartProp = {
  fromDateTime?: string | null;
  toDateTime?: string | null;
  generateKey?: number | null | undefined;
  id?: number | string;
  selectedDashboard?:string|null
};

const HighChart = ({ fromDateTime, toDateTime, generateKey, id,selectedDashboard}: chartProp) => {


  const [isEnabled, setIsEnabled] = useState<any>(false)
  const [pumpingStationData, setPumpingStationData] = useState<any[]>()
  const [pumpingstation, setPumpingStation] = useState<any[]>()
  const [dropdownOpen, setDropdownOpen] = useState<boolean>()
  const [selectedPumpingStation, setSelectedPumpingStation] = useState<string>('')
  const [autoSlide, setAutoSlide] = useState(true);

  const [startIndex, setStartIndex] = useState(0);
  const windowSize = 5; // show 10 bars at a time


  const toggleDropdown = () => setDropdownOpen(prev => !prev)

  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 6); 
  startDate.setHours(0, 0, 0, 0);

  useEffect(() => {
    if (!autoSlide) return;
    if (!pumpingStationData) return;
    if (pumpingStationData.length <= windowSize) return;
  
    const interval = setInterval(() => {
      setStartIndex((prev) => {
        const next = prev + windowSize;
        return next >= pumpingStationData.length ? 0 : next;
      });
    }, 10000); // 10 seconds
  
    return () => clearInterval(interval);
  
  }, [autoSlide, pumpingStationData?.length, windowSize]);
  


  const getPumpingStationHistory = async () => {
    try {
      const response = await ApiService.axiosApi(`/pumpingstation/dailyvolume`, {
        method: 'GET',
        params: {
       
          pageNumber: 0,
          pageSize: 0,
          fromDate: fromDateTime == null ? format(startDate, 'yyyy-MM-dd HH:mm:ss') : format(fromDateTime, 'yyyy-MM-dd HH:mm:ss'),
          toDate: toDateTime == null ? format(endDate, 'yyyy-MM-dd HH:mm:ss') : format(toDateTime, 'yyyy-MM-dd HH:mm:ss')
        }
      })
      if (response.success) {

        
        setPumpingStationData(response.data.data)

      } else {
        toast.error('Unable to get data at this moment')
      }
    } catch (error) {
      console.log(error)
    }


  }

  useEffect(() => {
    getPumpingStationHistory()
  }, [generateKey])

  useEffect(() => {
    const getPumpingStation = async () => {

      try {
        const response = await ApiService.axiosApi(`/pumpingstation`, {
          method: 'GET',
          params: {
            pageNumber: 0,
            pageSize: 0
          }
        })

        if (response.success) {

          setPumpingStation(response.data.data)
        } else {
          console.log('Unable to get Pumping station')
        }
      } catch (error) {
        console.log(error)
      }

    }
    getPumpingStation();
  }, [])

  const handleNext = () => {
    if (pumpingStationData && startIndex + windowSize < pumpingStationData.length) {
      setStartIndex(startIndex + windowSize);
    }
  };

  const handlePrev = () => {
    if (startIndex - windowSize >= 0) {
      setStartIndex(startIndex - windowSize);
    }
  };

  useEffect(() => {
    if (!autoSlide) {
      const timeout = setTimeout(() => setAutoSlide(true), 30000);
      return () => clearTimeout(timeout);
    }
  }, [autoSlide]);
  


   const visibleData = pumpingStationData?.slice(startIndex, startIndex + windowSize) || [];





  return (
    <Card
      className=" card-hover p-0 b-r-0"
      style={{width:'100%'}}
    >
      <CardHeader className="custom-border-bottom ">
        <div className="d-flex justify-content-between align-items-center">
        <span>
          <h5 style={{ fontWeight: '600' }}>Volume(m³)</h5>
          <h6 style={{fontSize:'12px'}}> {fromDateTime ? format(new Date(fromDateTime), "dd/MM/yyyy ") : format(startDate,"dd/MM/yyyy ")} -
          {toDateTime ? format(new Date(toDateTime), "dd/MM/yyyy ") : format(endDate,"dd/MM/yyyy ")}</h6>
          </span>

          <div className='d-flex'>
             <button className="icon-button " onClick={() => {
    setAutoSlide(false);
    handlePrev();
  }} disabled={startIndex === 0}><LeftIcon /></button>

             <button className="icon-button" onClick={()=>{
              setAutoSlide(false)
              handleNext();

             }} disabled={pumpingStationData && startIndex + windowSize >= pumpingStationData.length}><RightIcon /></button>
          </div>

        </div>

      </CardHeader>
      <CardBody className="p-1  my-2" >
        <LineChart style={{ width: '100%' }} width={600} height={355} data={visibleData}>
          <XAxis dataKey="dateTime"
              tick={{ fontSize: 15, textAnchor: 'middle',   }} 
              tickMargin={5}          
              interval={0}
              tickFormatter={(value) => {
                const date = new Date(value);
                return date.toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                 
                });
              }}
              />
          <YAxis
           
            dataKey={"main_Hl_Ft_Vol"}
            label={{
             
              value: "Daily Volumes Trend",
              angle: -90,
              position: "insideLeft",
              style: { textAnchor: "middle" },
              dx:-20
            }} 
            
            tick={({ x, y, payload }) => (
              <text
                x={x}
                y={y}
                textAnchor="end"
                dominantBaseline="start"
                
                fill="#666"
                fontSize={12}
              >
                {payload.value}
              </text>
            )}
            
            />
             <Tooltip
              formatter={(value: number, name: string) => [
                `${value} m³`,
                name === "main_Hl_Ft_Vol" ? "Volume" : " ",

              ]}

              labelFormatter={(label) =>
                new Date(label).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
              }

              cursor={false}
            />
          <CartesianGrid stroke="#ccc" strokeDasharray="1 1" />
          <Line type="linear" dataKey="main_Hl_Ft_Vol" stroke="#2B5F60" />
          onMouseEnter={() => setAutoSlide(false)}
          onMouseLeave={() => setAutoSlide(true)}
        </LineChart>
      </CardBody>
    </Card>
  )
}

export default HighChart